document.addEventListener('turbolinks:load', function() {
	const color_field = document.getElementById('name_petal_color_rgb');
	if (color_field !== null) {
		color_field.addEventListener('change', function() { document.getElementById('rgb_text').innerHTML = color_field.value; });
	}
});
